import { resolveWorkPathPrefix } from '@/lib/resolve-fanfic-work-list-base';
import type { SearchResultItem } from '../types';

export function getSearchResultRoute(item: SearchResultItem): string {
  if (item.type === 'author') {
    return `/author/${item.id}`;
  }

  if (item.type === 'fanfic') {
    return `${resolveWorkPathPrefix(item.workType)}/${item.id}`;
  }

  return `/article/${item.slug}`;
}
